import request from '../request';
import md5 from 'js-md5';

export const partnerApi = {
  getPartnerInfo() {
    return request.get('/gw/a/partner/info');
  },
  subscribePartner(data) {
    data.payPassword = md5(data.payPassword);
    let _data = {
      ...data,
    };
    return request({
      url: '/gw/a/partner/subscribe',
      method: 'post',
      data: _data,
    });
  },

  rejectPartnerInvitation() {
    return request({
      url: '/gw/a/partner/reject',
      method: 'post',
      data: {},
    });
  },
  getPartnerTypeData() {
    return request.get('/gw/w/res/partner_type');
  },
};